import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BarcodeFormat } from '@zxing/library';
import { TagType } from '../../../domain/administration/parker-administration/edit-parker-form/edit-parker-edit-tag-list-form/tag-type.enum';
import { DropDownConstantsFactory } from '../syncfusion/dropdown-constants-factory';
import { TranslateModule } from '@ngx-translate/core';
import { ZXingScannerModule } from '@zxing/ngx-scanner';
import { DropDownListModule } from '@syncfusion/ej2-angular-dropdowns';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-barcode-scanner',
    templateUrl: './barcode-scanner.component.html',
    styleUrls: ['./barcode-scanner.component.scss'],
    imports: [DropDownListModule, ZXingScannerModule, NgClass, TranslateModule]
})
export class BarcodeScannerComponent implements OnInit {

  @Input() public allowedFormats: BarcodeFormat[] = [BarcodeFormat.QR_CODE, BarcodeFormat.CODE_128];
  @Input() public clientIdent: string;
  @Input() public tagType: TagType;
  @Input() public useInternalValidation = true;

  @Output() public dataScanned = new EventEmitter();
  @Output() public cameraError = new EventEmitter();
  @Output() public cameraStarted = new EventEmitter();

  public dropdownSettings = DropDownConstantsFactory.createStandardClientDropdownSettings();

  public showCamera = true;
  public cameraStarting = true;
  public permissionAllowed = true;
  public camerasFound = true;

  public activeCamera: MediaDeviceInfo;
  public cameras: MediaDeviceInfo[] = [];
  public camerasDropdownValues: {name: string; id: string}[] = [];

  public invalidBarcodeError = false;

  constructor() {
  }

  public ngOnInit(): void {
  }

  public onAutostarting(event): void {
    this.cameraStarting = event;
    if (!event) {
      this.cameraStarted.emit();
    }
  }

  public onNoCameraFound(event): void {
    this.camerasFound = !event;
    this.showCamera = this.showCamera && this.camerasFound;
    this.onError('no camera found');
  }

  public onPermissionResponse(event): void {
    this.permissionAllowed = event;
    this.showCamera = this.showCamera && this.permissionAllowed;
    if (!this.permissionAllowed) {
      this.onError('permission denied');
    }
  }

  public onScanComplete(event: any): void {
    if (event) {
      if (this.validateScannedCode(event.text)) {
        this.dataScanned.emit(event.text);
      } else {
        this.invalidBarcodeError = true;
      }
    } else {
      this.invalidBarcodeError = false;
    }
  }

  public onError(event): void {
    this.cameraError.emit(event);
  }

  public onCamerasFound(event): void {
    this.cameras = event;
    this.camerasDropdownValues = event.map(camera => ({name: camera.label, id: camera.deviceId}));
  }

  public setActiveCamera(event): void {
    if (this.activeCamera.deviceId !== event) {
      this.activeCamera = this.cameras.find(camera => camera.deviceId === event);
    }
  }

  private validateScannedCode(code: string): boolean {
    if (!this.useInternalValidation) {
      return true;
    }
    // code format: clientIdent.type.ident
    const codeArray = code.split('.');

    if (codeArray.length !== 3) {
      return false;
    }

    const clientIdent = codeArray[0];
    const type = codeArray[1];

    if (clientIdent !== this.clientIdent) {
      return false;
    }

    if (TagType[type] !== this.tagType) {
      return false;
    }

    return true;
  }
}

